function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.45,17.962l-0,-0.375c-0,-0.814 -0,-1.221 -0.094,-1.554c-0.236,-0.837 -0.89,-1.491 -1.727,-1.727c-0.333,-0.094 -0.74,-0.094 -1.554,-0.094l-3.667,-0c-0.814,-0 -1.221,-0 -1.553,0.094c-0.838,0.236 -1.492,0.89 -1.728,1.727c-0.094,0.333 -0.094,0.74 -0.094,1.554l0,0.375",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.449,15.045l0,-1.333c0,-0.697 0,-1.046 0.069,-1.334c0.22,-0.914 0.933,-1.627 1.848,-1.847c0.287,-0.069 0.636,-0.069 1.333,-0.069l0.084,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.366,8.379c0,1.61 -1.305,2.916 -2.916,2.916c-1.611,0 -2.917,-1.306 -2.917,-2.916c0,-1.611 1.306,-2.917 2.917,-2.917c1.611,-0 2.916,1.306 2.916,2.917Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.115,4.112c-0.488,-0.693 -1.324,-1.15 -2.272,-1.15c-1.507,-0 -2.728,1.152 -2.728,2.573c0,1.121 0.759,2.074 1.818,2.427",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px",
      strokeLinejoin: "miter"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsSelected);
export default __webpack_public_path__ + "static/media/clients_selected.dee547e9890a1c5a5ec58d7dae442ab3.svg";
export { ForwardRef as ReactComponent };